import {SimpleModule} from 'ca-middleware';
import {mapService } from '@/api/installService';
import MapShare from './map/MapShare';
export class MapModule extends SimpleModule {

    constructor() {
        super();
    }

    public configureView() {
        this.addComponent('MapLayout');
        // 地图全局共享变量
        this.registerGlobal('mapShare', new MapShare());
    }

    public configureService() {
        this.addService('mapService', mapService);
    }
}
